export class Pagination {
  public readonly total: number;
  public readonly totalPages: number;

  constructor(meta?: { total?: number; last_page?: number } | null) {
    this.total = meta?.total ?? 0;
    this.totalPages = meta?.last_page ?? 1;
  }
}
